import { render, staticRenderFns } from "./TabelaPrecoListAddNew.vue?vue&type=template&id=6db6ce4c&"
import script from "./TabelaPrecoListAddNew.vue?vue&type=script&lang=js&"
export * from "./TabelaPrecoListAddNew.vue?vue&type=script&lang=js&"
import style0 from "./TabelaPrecoListAddNew.vue?vue&type=style&index=0&id=6db6ce4c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports